'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.ControlNoop',

  render: function render() {
    return null;
  }
});
module.exports = exports['default'];